

import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, IconButton, Typography } from "@mui/material"
import { iconos } from "../../data";







export const LayoutReturn = ({ children, titulo, url }) => {


    const navigate = useNavigate();


    const handleReturn = () => {
        if(!isNaN(url)) {
            navigate(url * -1)
        }else {
            navigate(`${url}`)
        }
    }



    return (

        <Grid container sx={{height:'calc(100% - 67px)', width:'100%', background:'white', p:4, mt:0.5}}>
            <Grid item xs={ 12 } sx={{ display:'flex', alignItems:'center', mb:2, height:'5%'}}>
                <Typography variant='h4'>{ titulo }</Typography>

                <Box flex={1} />

                <Button variant="contained" color='secondary'
                        sx={{ color: '#fff', ':hover': { opacity: 0.5 }, py:1 }} onClick={ handleReturn }>
                        { iconos['back'] } 
                </Button>
            </Grid>



            <Grid item xs={12} sx={{width:'100%', height:'92%', mt:2}}>
                { children }
            </Grid>
        </Grid>
        
    )
}
